export function rmUnderscores(condition) {
  // TODO: Additional catches will be added here and to the test per
  // https://climate.jira.com/projects/CFVWEB/issues/CFVWEB-8343
  const formattedCondition = condition.split('_').join('');
  return formattedCondition;
}
